import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const MinWidthSelector = styled.div`
  width: 244px;
  .position-content {
    min-width: 284px;
  }

  .dropdown-panel {
    min-width: 284px;
  }

  .dropdown-panel-min-width {
    .position-content {
      min-width: 284px;
    }
    .dropdown-panel {
      min-width: 284px;
    }
  }
`;

export const Wrapper = styled.div`
  margin-left: 10px;

  display: flex;
  align-items: center;
`;

export const StyledTitle = styled.div`
  font-family: inherit;
  font-size: 13px;
  color: ${TextColorNames.secondary};
  line-height: 18px;
  display: flex;
  margin-right: 10px;
`;

export const OptionEmpty = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0;

  svg {
    margin-right: 10px;
  }
`;

export const OptionLabel = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.tertiary};
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;

  svg {
    margin-right: 10px;
  }
`;
